import { ReactElement } from 'react';
import { useIsMobile, useToast } from '@hooks';
import Modal from '@components/Modal';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@tsClient';
import AddUserWorkflowCollaboratorForm from '@components/AddUserWorkflowCollaboratorForm';

type Props = {
  userWorkflowId: string;
  onClose: () => void;
  onSubmit: (collaborator: Awaited<ReturnType<typeof tsClient.workflows.addUserWorkflowCollaborator>>) => void;
};

const AddUserWorkflowCollaboratorModal = ({ userWorkflowId, onClose, onSubmit }: Props): ReactElement => {
  const isMobile = useIsMobile();

  const {
    fetchingState: addingTeamMember,
    getData: addCollaboratorFn,
  } = useNoodleApi(tsClient.workflows.addUserWorkflowCollaborator, {
    toastOnError: true,
    toastSuccessMessage: () => [useToast.ToastTypeVariants.INFO, 'Collaborator added'],
  });

  const handleAddTeamMember = async (name: string, email: string): Promise<void> => {
    const response = await addCollaboratorFn({
      email,
      name,
      sendEmail: true,
      userWorkflowId,
    });
    if (response.data) {
      onSubmit(response.data);
    }
  };

  return (
    <Modal
      hideBottomInset
      isPinnedToBottom={isMobile}
      title={'Invite collaborator'}
      onClose={onClose}
      hasCloseOnActions={false}
    >
      <AddUserWorkflowCollaboratorForm onSubmit={handleAddTeamMember} isSubmitting={addingTeamMember.isFetching}/>
    </Modal>
  );
};

export default AddUserWorkflowCollaboratorModal;